module.exports = __webpack_public_path__ + "img/icon-qd.51a7a1a9.svg";